import * as React from 'react';
import ThemeControls from "../AllThemesControl.js";
import Button from '../../FormsControls/Button.js';
import Element from '../../FormsControls/Element.js';
import { FormContext } from '../Forms/FormContext.js';
import CloseIcon from '@mui/icons-material/Close';
import { IoWarningOutline } from 'react-icons/io5';
import elementValidation from '../validation.js';
import Loading from '../../images/Table/Loading.gif';
import { APIGET, APIDEL, APIPOST } from '../../services/APIServices.js';
import { useParams } from 'react-router-dom';
import SuccessPage from '../SuccessPage.js';
import { useNavigate } from 'react-router-dom';
const delJSON = {
  "fields": [
    {
      "field_id": "endDate",
      "field_label": "Deal End Date",
      "field_mandatory": "yes",
      "field_placeholder": "",
      "field_type": "date",
      "field_value": "",
      "field_minlength": "2",
      "field_maxlength": "250",
      "field_minvalue": "",
      "field_maxvalue": "",
      "field_value_type": "Name",
      "field_on_blur": "",
      "field_error_msg_required": "Select Deal End Date",
      "field_error_msg_minlength": "",
      "field_error_msg_maxlength": "",
      "field_error_msg_minvalue": "",
      "field_error_msg_maxvalue": "",
      "field_error_msg_uq": ""
    }
  ]
}

export default function SubForm(props) {
  const { useStyles } = ThemeControls;
  const { apiContextObj, setEditData } = props;
  const [data, setData] = React.useState([]);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [elements, setElements] = React.useState(null);
  const { id } = useParams();
  const classes = useStyles();
  let navigate = useNavigate();
  const [successRender, setSuccessRender] = React.useState(undefined);
  const [successPageData, setSuccessPageData] = React.useState(undefined);
  const [btnLoading, setBtnLoading] = React.useState(false);
  function renderSuccessPage(props) {
    setSuccessPageData(props)
    setSuccessRender(1);
    //console.log('Success Rander is Rendering..')
  }

  function replaceDayWithLastDateOfMonth(dateString) {
    const parts = dateString.split('-');
    const year = parseInt(parts[2], 10);
    const month = parseInt(parts[1], 10);
    const lastDayOfMonth = new Date(year, month, 0).getDate();
    return `${lastDayOfMonth}-${parts[1]}-${parts[2]}`;
  }

  async function settingData(apiPath) {
    return await APIGET(apiPath).then(data => {
      try {
        if (data) {
          console.log(data)
          if (data.data && data.statusCode==='SUCCESS') {
            setSuccessRender(1);
            setBtnLoading(false)
            // setEditData([data.data])
            setData(data.data)
          } else if (data.serverMsg) {
            setErrorMsg(data.serverMsg)
            setBtnLoading(false)
          }
        }else {
          setBtnLoading(false)
          setErrorMsg("Server Error: Please try again later.", 'error')
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    })
  }

  function handleDealGen() {
    let validData = true;
    delJSON.fields.map((field, index) => {
      if (!elementValidation(field)) {
        validData = false;
      }
    });

    if (delJSON.fields[0].field_value && validData) {
      setBtnLoading(true)
      const endDate = replaceDayWithLastDateOfMonth(delJSON.fields[0].field_value)
      const path = `${apiContextObj.apiContextDealOverFlow}${id}&endDate=${endDate}`;
      settingData(path);
    }
  }

  React.useEffect(() => {
    setElements(delJSON.fields)

    delJSON.fields.map((field, i) => {
      (field.field_value = "")
    })
  }, [])


  const { fields } = elements ?? {}

  //handle change==>
  const handleChange = (id, event, valueStr) => {
    const newElements = { ...elements }
    setErrorMsg('')
    delJSON.fields.forEach(field => {
      const { field_type, field_id } = field;
      if (id === field_id) {
        switch (field_type) {
          case 'checkbox':
            field['field_value'] = event.target.checked;
            break;

          default:
            field['field_value'] = valueStr;
            break;
        }
      }
      setElements(newElements);
    });
  }
  const navigationHandle = (data) => {
    if(data&&data.dealinfoid){
      let path ='/deal/searchDeal'
      const id = data.dealinfoid
        let pathname = `${path}/${id}`;
        navigate(pathname, { state: data });
    }
  };
// console.log(data.dealinfoid)
// console.log(data.status)

  const handleClose = () => {
    props.close(false);
    if(data&&data.length>0){
      navigationHandle(data)
    }
    delJSON.fields.map((field, index) => {
      delJSON.fields[index].field_helperText = undefined;
      delJSON.fields[index].field_value = undefined;
    });
  }

  const handleCancel = () => {
    props.close(false);   
    delJSON.fields.map((field, index) => {
      delJSON.fields[index].field_helperText = undefined;
      delJSON.fields[index].field_value = undefined;
    });
  }
// console.log(apiContextObj.contextHeading)
  // if(!data){
  return (
    <>
      <div className={classes.closeup}>
        <CloseIcon onClick={handleClose} />
        <div className={classes.bdr}>
          <h4>Generate Overflow Deal</h4>
          <div></div>
        </div>
      </div>
      {(successRender) ?
        <SuccessPage
          flowName={apiContextObj.contextHeading}
          actionName="Generated"
        />
        :
        <div className={classes.preview}>
          <FormContext.Provider value={{ handleChange }}>
            <div className='App containers'>
              {delJSON.fields ? delJSON.fields.map((field, i) => <Element key={i} field={field} />) : null}
            </div>
          </FormContext.Provider>
          {errorMsg && <p className={classes.warningError}><IoWarningOutline />{errorMsg}</p>}
          <div className={classes.dealBtn}>
            <Button ButtonName="Cancel" onClick={() => (handleCancel())} />
            <Button disabled={btnLoading} ButtonName= {btnLoading?
                  <div class={classes.loading08}>
                    <span data-text="L">L</span>
                    <span data-text="O">O</span>
                    <span data-text="A">A</span>
                    <span data-text="D">D</span>
                    <span data-text="I">I</span>
                    <span data-text="N">N</span>
                    <span data-text="G">G</span>
                  </div>:'Generate'} 
                  onClick={() => handleDealGen()} />
          </div>
        </div>
      }
    </>
  )
  // }else{
  //   return <div className={classes.loading}><img src={Loading} alt="Loading..." /><CloseIcon onClick={()=>(handleCancel())}/></div>
  // }
}

